module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items) ? _c('div', {
    staticClass: "page4 animated fadeIn"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h3', {
    staticClass: "title animated fadeIn"
  }, [_vm._v(_vm._s(_vm.items.intro.title))]), _vm._v(" "), _c('p', {
    staticClass: "animated fadeIn",
    domProps: {
      "innerHTML": _vm._s(_vm.items.intro.text)
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "media/page4/transportMontage.png"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c9260b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page4.vue
// module id = 135
// module chunks = 0